import { render, staticRenderFns } from "./Alokasi.vue?vue&type=template&id=6543cffb"
import script from "./Alokasi.vue?vue&type=script&lang=js"
export * from "./Alokasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports